import { useEffect } from "react";
import { BRAND } from "@core/brand/brand-config";
import "./intel-mobile.scss";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import LocalStorageService from "../../../../core/services/local-storage.service";
import { toast } from "react-toastify";
import { getApiUrl } from "../../../../utils/baseUrl";
import { getAccountsUrl } from "../../../../utils/accountsUrl";
import { globalGetApiUrl } from "@utils/globalBaseUrl";
import * as Sentry from "@sentry/browser";
const intelMobileDashboard = {
  logoutUser: getApiUrl("logout"),
  profileComplete: globalGetApiUrl("auth/getUserProfileComplete"),
  profileIntel: getApiUrl("getUserIntelDetails"),
};
const localStorageService = LocalStorageService.getService();
export default function IntelMobileDashboard() {
  const history = useHistory();
  useEffect(() => {
    getUserData();
  }, []);
  const getUserData = async () => {
    try {
      // Call both APIs and merge responses
      const [profileCompleteResponse, intelDetailsResponse] = await Promise.all([axios.get(intelMobileDashboard.profileComplete), axios.get(intelMobileDashboard.profileIntel)]);
      const mergedData = {
        ...profileCompleteResponse.data,
        ...intelDetailsResponse.data,
      };
      return mergedData;
    } catch (error) {
      toast.error("Error fetching user profile:", error);
      Sentry.captureException(error);
      // Fallback to profileComplete only if intelDetails fails
      try {
        const profileCompleteResponse = await axios.get(intelMobileDashboard.profileComplete);
        return profileCompleteResponse.data;
      } catch (fallbackError) {
        toast.error("Error fetching profile complete:", fallbackError);
        Sentry.captureException(error);
        return null;
      }
    }
  };
  const logoutButtonFunction = () => {
    axios.get(intelMobileDashboard.logoutUser).then((res) => {
      if (res.data.status.toLocaleUpperCase() === "Success".toLocaleUpperCase()) {
        localStorageService.clearCompleteStorage();
        window.href = getAccountsUrl() + "?&logout=true";
      } else {
        toast.error(res.data.message);
      }
    });
  };
  const proceedToSearch = () => {
    history.push("/search-shipments");
  };
  return (
    <div>
      <div className="text-center py-5 px-3 intel-mobile-view">
        <Link to={{ pathname: "/" }} className="trademo-logo" onClick={logoutButtonFunction}>
          <img className="img-fluid" src={"https://res.cloudinary.com/drzta9shk/image/upload/v1708336920/website/HomePage_Feb24/logo_black_yf35fh.svg"} alt="trademo-logo"></img>
        </Link>
        <div>
          <div className="my-5">
            <img src={"https://res.cloudinary.com/drzta9shk/image/upload/v1744871733/intel/Emails/M-2_fb7jmw.png"} alt="trademo_background" className="w-75 img-fluid" />
          </div>
        </div>
        <p className="para-text">{BRAND.name} is best optimised for desktop resolution</p>
        <div className="mt-3">
          <button type="button" className="btn btn-link trademo-link" onClick={proceedToSearch}>
            Proceed to Search
          </button>
        </div>
        <div>
          <button type="button" className="btn btn-link trademo-link" onClick={logoutButtonFunction}>
            Logout and Go to Homepage
          </button>
        </div>
      </div>
    </div>
  );
}
